import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, Typography, Avatar, Button, ButtonBase, List, } from '@material-ui/core';
import Apis from '../../../network/Apis';
import AppData from '../../../model/AppData';
import MSnackbar from '../../view/MSnackbar';

const ICON_XINXIANG = require("../../../images/icons/sixin_icon.png");


class MovieAnchor extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            value: '',
            isStar: AppData.isStarAnchor(this.props.data.user_id),
            showChat: true,
        };
        console.log('MovieAnchor===>', props);
    }

    componentDidMount() {
        this.encryptionServerConfig();
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    encryptionServerConfig = async () => {
        let is_has_private = 0;
        if (!AppData.ServerConfig) {
            let res = await Apis.encryptionServerConfig();
            console.log("encryptionServerConfig", res);
            if (res.code == 200 && res.data) {
                AppData.ServerConfig = res.data;
            }
        }
        is_has_private = AppData.ServerConfig.is_has_private;
        if (AppData.IsCloseChat) {
            is_has_private = 2;
        }
        this.setState({ showChat: is_has_private == 1 });
    }



    starAnchor = async () => {
        let result = await Apis.encryptionFocusHost(JSON.stringify([this.props.data.user_id]));
        console.log('starAnchor', result);
        if (result.code == 200) {
            if (result.data) {
                AppData.getStarAnchor();
            }
        }
    }

    unStarAnchor = async () => {
        let result = await Apis.encryptionFocusHost(this.props.data.user_id, 1);
        console.log('unStarAnchor', result);
        if (result.code == 200) {
            if (result.data) {
                AppData.getStarAnchor();
            }
        }
    }

    _onClickStar = () => {
        if (!AppData.me.isLogin()) {
            this.props.history.push('/login');
            return;
        }
        let isStar = !this.state.isStar;
        this.setState({ isStar: isStar });
        if (isStar) {
            this.starAnchor();
        } else {
            this.unStarAnchor();
        }
    }

    _onClickMessage() {
        // if (!AppData.me.isLogin()) {
        //     this.props.history.push('/login');
        //     return;
        // }
        // let { user_id } = this.props.data;
        // if (!AppData.isStarAnchor(user_id)) {
        //     if (this.refs.toast) {
        //         this.refs.toast.show('关注主播才可以私信哦~');
        //         return;
        //     }
        // }
        // console.log('_onClickMessage', this.props.data); 

        let { data } = this.props;
        this.props.history.push({ pathname: '/privateletter/' + data.user_id + '/userProfile', data: data.nickname });
    }

    render() {
        const { classes, data, } = this.props;
        const { isStar, showChat } = this.state;
        return (
            <List className={classes.root}>
                <Grid container direction='column' alignItems='center'>
                    <Grid container direction='row' justify='space-between' alignItems='center' style={{ width: '100vw', marginTop: 16 }}>
                        <Avatar src={this.props.data.portrait} className={classes.avatar}></Avatar>
                        <Grid container direction='column' style={{ flex: 1, marginLeft: 16 }}>
                            <Typography style={{ color: '#0D0D0D', fontSize: 14, fontWeight: 'bold' }}>{data.nickname}</Typography>
                            <Typography style={{ color: '#878787', fontSize: 9, }}>{'房间号：' + data.room_id + '      粉丝：' + data.fans_number + '人'}</Typography>
                            {/* <Grid container direction='row'>
                                <Button size='small' className={classes.button} style={{ backgroundColor: '#F7B44B', marginLeft: 0, marginTop: 4 }}>中超</Button>
                                <Button size='small' className={classes.button} style={{ backgroundColor: '#F486E3', marginLeft: 4, marginTop: 4 }}>意甲</Button>
                                <Button size='small' className={classes.button} style={{ backgroundColor: '#8F63F1', marginLeft: 4, marginTop: 4 }}>西甲</Button>
                            </Grid> */}
                        </Grid>
                        <ButtonBase disableRipple onClick={() => this._onClickStar()} className={isStar ? classes.dy1Button : classes.dyButton}>{isStar ? '已关注' : '关注'}</ButtonBase>
                    </Grid>
                    <Grid container direction='column' style={{ width: '100vw', marginTop: 16 }}>
                        <Typography style={{ color: '#0D0D0D', fontSize: 12, marginLeft: 8, fontWeight: 'bold', lineHeight: 1.5 }}>直播公告</Typography>
                        <Typography style={{ color: '#878787', fontSize: 11, marginLeft: 8, marginTop: 8 }}>{data.live_trailer}</Typography>
                    </Grid>
                    {showChat && <Grid container direction='row' justify='center' alignItems='center' style={{
                        width: '100vw',
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        height: 55,
                        backgroundColor: '#FFF'
                    }}>
                        <ButtonBase disableRipple onClick={() => this._onClickMessage()}  >
                            <img src={ICON_XINXIANG} style={{ width: 15, height: 15 }}></img>
                            <Typography style={{ color: '#0D0D0D', fontSize: 14, marginLeft: 4 }}>私信(TA)</Typography>
                        </ButtonBase>
                    </Grid>}
                </Grid>
                <MSnackbar ref='toast' />
            </List >
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: '100%',
        height: '100%',
        borderRadius: 10,
        backgroundColor: 'transparent',
        flex: 1,
    },
    avatar: {
        width: 60,
        height: 60,
        marginLeft: 8,
    },
    dyButton: {
        minWidth: 50,
        backgroundColor: theme.palette.primary.main,
        height: 25,
        borderRadius: 12.5,
        marginRight: 8,
        color: '#FFF',
        fontSize: 12,
    },
    dy1Button: {
        minWidth: 50,
        backgroundColor: '#FFF',
        height: 25,
        borderRadius: 12.5,
        marginRight: 8,
        color: '#878787',
        fontSize: 12,
    },
    button: {
        paddingLeft: 4,
        paddingRight: 4,
        marginRight: 4,
        marginLeft: 4,
        marginTop: 0,
        marginBottom: 0,
        minWidth: 48,
        lineHeight: 1.3,
        color: '#FFF'
    }

}))(MovieAnchor));